export const SERVICES = {
  geocollections: {
    title: "geocollections.title",
    description: "geocollections.description",
    href: "https://geocollections.info",
  },
  kirjandus: {
    title: "kirjandus.title",
    description: "kirjandus.description",
    href: "https://kirjandus.geoloogia.info",
  },
  gmre: {
    title: "gmre.title",
    description: "gmre.description",
    href: "https://geoloogia.info/geology",
  },
  fond: {
    title: "fond.title",
    description: "fond.description",
    href: "https://fond.egt.ee",
  },
  // Divider
  fossiilid: {
    title: "fossiilid.title",
    description: "fossiilid.description",
    href: "https://fossiilid.info",
  },
  kivid: {
    title: "kivid.title",
    description: "kivid.description",
    href: "https://kivid.info",
  },
  stratigraphy: {
    title: "frontStratigraphy.title",
    description: "frontStratigraphy.description",
    href: "https://stratotuup.ut.ee",
  },
  // Divider
  geologicalSurvey: {
    title: "geologicalSurvey.title",
    description: "geologicalSurvey.description",
    href: "https://gis.egt.ee/",
  },
  maardlad: {
    title: "maardlad.title",
    description: "maardlad.description",
    href: "https://xgis.maaamet.ee/xgis2/page/app/geoloogia400k",
  },
  doi: {
    title: "doi.title",
    description: "doi.description",
    href: "https://doi.geocollections.info",
  },
  turba: {
    title: "turba.title",
    description: "turba.description",
    href: "https://turba.geoloogia.info",
  },
  // Divider
  geocase: {
    title: "geocase.title",
    description: "geocase.description",
    href: "https://geocase.eu",
  },
  eurocore: {
    title: "eurocore.title",
    description: "eurocore.description",
    href: "https://eurocore.rocks",
  },
  sarv: {
    title: "sarv.title",
    description: "sarv.description",
    href: "https://edit.geocollections.info",
  },
  ids: [
    "kirjandus",
    "fossiilid",
    "kivid",
    "fond",
    "geologicalSurvey",
    "maardlad",
    "stratigraphy",
    "gmre",
    "turba",
    "geocase",
    "eurocore",
    "geocollections",
    "doi",
    "sarv",
  ] as
    ("kirjandus" |
      "fossiilid" |
      "kivid" |
      "fond" |
      "geologicalSurvey" |
      "maardlad" |
      "stratigraphy" |
      "gmre" |
      "turba" |
      "geocase" |
      "eurocore" |
      "geocollections" |
      "doi" |
      "sarv")[]

  ,
};
